import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ResultInfo from './common/ResultInfo';
import XbtnTitleHeader from '../../../common/header/XbtnTitleHeader';

import { mathpidLogAPICall } from '../../../../redux/logData';
import { diagnosisResultAPI } from '../../../../api/diagnosisAPI';
import { useUserInfo, useRequest, useLearningHistory, useAppBackBtn, useHackle } from '../../../../hooks';
import useAmplitude from '../../../../hooks/useAmplitude';
import { useHistory } from 'react-router-dom';
import { TYPE, URL } from '../../../../constant';
import { appsflyer, appsflyerEventName } from '../../../../utils/appsflyer';

function ResultV2() {
  const { info } = useUserInfo();
  const { t } = useTranslation();
  const { setBackEventData } = useAppBackBtn();
  const { setAmplitudeLog } = useAmplitude();

  const logDispatch = useDispatch();
  const { setLearningHistoryInfo } = useLearningHistory();
  const [diagnosisResultAPICall, result] = useRequest((data) =>
    diagnosisResultAPI(data)
  );
  const history = useHistory();
  const { setHackleInfo, clearHackleInfo } = useHackle();

  const onClose = () => {
    history.replace(`${URL.SELECT_LEARNING}`);
  };

  useEffect(() => {
    if (!info?.learnerId) return;
    const { learnerId, locale } = info;

    diagnosisResultAPICall({
      lrnMbrId: learnerId,
      langCd: locale
    });
    setLearningHistoryInfo({
      isCompleteAIDiagnosis: 'Y',
      isCheckAIDiagnosisResult: 'Y'
    });

    if (info.channelCode === TYPE.CHANNEL.GLOBAL01) {
      setBackEventData({ pathname: URL.SELECT_LEARNING });
      setHackleInfo( { viewPath : 'LEARNING_RESULT', isShowHackle : true } ); // hackle 적용
    }

    return () => {
      if (info.channelCode === TYPE.CHANNEL.GLOBAL01) {
        clearHackleInfo( { viewPath : 'LEARNING_RESULT' } );
      }
    }
  }, []);
  
  useEffect(() => {
    if (!result) return;

    logDispatch(mathpidLogAPICall({
      verbId: 'opened',
      objectId: 'learningReport',
      idName: 'estLastStgCd',
      idValue: result.estLastStgCd,
    }));

    setAmplitudeLog({
      eventName: {
        name: '진단test 종료',
        event: {
          "제시된 문항 수": result?.totQstCt,
          "진단test level": result.estPreLvlDspOdr,
        }
      },
      isHackleSend: true,
    })
    appsflyer({
      eventName: appsflyerEventName.test_completed,
      eventParams: {
        af_level: result.estPreLvlDspOdr,
      }
    });
    setAmplitudeLog({ eventCategory: 'lms', eventName: '진단결과 조회' });
  }, [result]);

  if (!result) return <div></div>;

  return (
    <React.Fragment>
      <div className="layout-def layout-lc layout-lr layout-lr-dark">
        <XbtnTitleHeader
          title={t("LC_02_09_result.msg001")}
          onClose={onClose}
        />
        <div className="container">
          <div className="inner">
            {/* 진도학습 결과와 같은 부분 */}
            <ResultInfo result={result}/>
          </div>
        </div>

      </div>
    </React.Fragment>
  );
}

export default ResultV2;